import qs from 'qs'

import request from 'api/requestUtils'

const OFFER_VIEWS_LIMIT = 100

interface SalesLaunchpadOfferPageViewItem {
  offerId: string | null
  productId: string | null
  categoryId: string | null
  vertical: string | null
}

interface SalesLaunchpadOfferPageView {
  id: string
  customerId: string
  occurredAt: string
  actor: {
    type: App.SpoofLaunchpadActorType
    agentId: string | null
  }
  item: SalesLaunchpadOfferPageViewItem | null
}

interface SalesLaunchpadOfferPageViewsResult {
  offerPageViews: Array<SalesLaunchpadOfferPageView>
}

function mapSnowplowItemToOfferType(item: SalesLaunchpadOfferPageViewItem | null): string {
  if (!item) return 'hotel'

  if (item.vertical) return item.vertical

  const productId = item.productId?.toLowerCase() ?? ''
  const categoryId = item.categoryId?.toLowerCase() ?? ''

  if (categoryId === 'cruise' || productId === 'cruise' || productId === 'cruisebank') {
    return 'cruise'
  }
  if (categoryId === 'experience' || productId.endsWith('_exp') || productId === 'experience') {
    return 'experience'
  }
  if (categoryId === 'tour' || productId === 'tour' || productId === 'tour_v2') {
    return 'tour'
  }
  if (productId === 'bedbank') {
    return 'bedbank'
  }

  return 'hotel'
}

function mapOfferView(view: SalesLaunchpadOfferPageView): App.SpoofLaunchpadOfferView | undefined {
  const offerId = view.item?.offerId
  if (!offerId) return undefined

  return {
    id: view.id,
    offerId,
    offerType: mapSnowplowItemToOfferType(view.item),
    occurredAt: view.occurredAt,
    actor: {
      type: view.actor.type,
      agentId: view.actor.agentId ?? undefined,
    },
  }
}

/**
 * Recent offer page views for the Spoof Launchpad, sourced from the fs-ai-ops
 * Sales Launchpad offer-page-views endpoint.
 */
export async function getSpoofLaunchpadOfferViews(
  customerId: string,
): Promise<Array<App.SpoofLaunchpadOfferView>> {
  const query = qs.stringify({ customer_id: customerId, limit: OFFER_VIEWS_LIMIT })
  const response = await request.get<App.ApiResponse<SalesLaunchpadOfferPageViewsResult>>(
    `/api/ai-ops/v1/sales-launchpad/offer-page-views?${query}`,
    { credentials: 'include', excludeBrand: true },
  )

  return response.result.offerPageViews
    .map(mapOfferView)
    .filter((view): view is App.SpoofLaunchpadOfferView => !!view)
}
